import React, { useState } from 'react';
import {
  ControlLabel,
  FormControl,
  FormGroup,
  InputGroup,
} from 'react-bootstrap';
import CloseButton from 'react-bootstrap/lib/CloseButton';
import {
  withTranslation,
  WithTranslation,
} from 'react-i18next';
import { observer } from 'mobx-react';

type Option = {
  value: string;
  label: string;
};

type DropdownWithCustomValueProps = WithTranslation & {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder: string;
  options: Option[];
};

const DropdownWithCustomValue: React.FC<DropdownWithCustomValueProps> = (props) => {
  const { value, onChange, label, placeholder, options, t } = props;
  const [usingCustomValue, setUsingCustomValue] = useState(false);

  const handleOnChange = (e: React.ChangeEvent<FormControl & HTMLInputElement>) => {
    const newValue = e.currentTarget.value;
    if (newValue === 'custom') {
      setUsingCustomValue(true);
      onChange('');
    } else {
      onChange(newValue);
    }
  };

  if (usingCustomValue) {
    return (
      <FormGroup>
        <ControlLabel>{label}</ControlLabel>
        <InputGroup>
          <FormControl
            type="text"
            value={value}
            onChange={handleOnChange}
            placeholder={placeholder}
            bsSize="sm"
          />
          <InputGroup.Addon>
            <CloseButton
              aria-label={t('Clear')}
              onClick={() => {
                setUsingCustomValue(false);
                onChange('');
              }}
            />
          </InputGroup.Addon>
        </InputGroup>
      </FormGroup>
    );
  }

  return (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <FormControl
        name="hauler"
        componentClass="select"
        value={value}
        onChange={handleOnChange}
        bsSize="sm"
      >
        <option value="" />
        <option key={'hauler-custom'} value="custom">
          {t('Custom value...')}
        </option>
        {options.map((option, index) => (
          <option
            key={`${option.value}-${index}`}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </FormControl>
    </FormGroup>
  );
};

export default withTranslation()(observer(DropdownWithCustomValue));
